
import React, { memo } from 'react';
import TextParagraph from '../ui/TextParagraph';
import { isExecutiveSummary } from '@/utils/report/sectionUtils';

interface ParagraphSectionProps {
  content: string;
  index: number;
  sections: string[];
}

const ParagraphSection: React.FC<ParagraphSectionProps> = ({ content, index, sections }) => {
  // Detect if this is part of the executive summary
  const executiveSummary = isExecutiveSummary(content, index, sections);
  
  return (
    <TextParagraph 
      key={index} 
      text={content}
      isExecutiveSummary={executiveSummary} 
      className="my-4 text-base"
    />
  );
};

export default memo(ParagraphSection);
